// @flow
import React from "react";
import Button from "./Button";
import thinkingFace from "../../static/emoji/1f914.svg";

type Props = {
  title: string,
  text: string,
  start: () => void
};

const Intro = ({ title, text, start }: Props) =>
  <div className="intro">
    <img className="splash" src={thinkingFace} alt="Thinking face emoji" />
    <div className="text">
      <h1 className="title">{title}</h1>
      <div className="subtitle">{text}</div>
    </div>
    <div className="controls">
      <Button label="Start the quiz" onClick={start} />
    </div>
    <style jsx>{`
      .intro {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100vh;
        padding: 20px;
      }
      .splash {
        width: 140px;
        height: 140px;
      }
      .text {
        width: 100%;
        padding: 5vw 0 5vw 0;
      }
      .title {
        font-family: FrutigerLTCom;
        font-weight: 300;
        font-size: 24px;
        line-height: 26px;
        text-align: center;
        margin: 0 0 16px 0;
        width: 100%;
      }
      .subtitle {
        font-family: FrutigerLTCom;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        width: 100%;
        max-width: 640px;
        margin: 0 auto;
      }
      .controls {
        max-width: 320px;
        margin: 0 auto 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    `}</style>
  </div>;

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Quiz/Intro.js